export const EVENTS = {
  APP_CHANGE_PAGE_ROUTE: 'App - change_page_route',
  HEADER_TIMELINE_BTN: 'Header - timeline_btn', //

  NAVIGATION_DRAWER_NEW_ORDER: 'Menu_NewOrder', //
  NAVIGATION_DRAWER_RECORDS: 'Menu_Records', //
  NAVIGATION_DRAWER_BALANCE: 'Menu_Balance', //
  NAVIGATION_DRAWER_EMPLOYEE: 'Profile_select_employee', //
  NAVIGATION_DRAWER_REFERRAL_CODE: 'Menu_InviteFriends', //
  NAVIGATION_DRAWER_LOGIN: 'Menu_Login', //
  NAVIGATION_DRAWER_RO: 'Menu_RouteOptimization', //
  NAVIGATION_DRAWER_GAMIFICATION: 'Menu_Rewards', //
  NAVIGATION_DRAWER_NOTIFICATION: 'Menu_News', //
  NAVIGATION_DRAWER_STATISTIC: 'Menu_Statistic', //
  NAVIGATION_DRAWER_HELP: 'Menu_Help', //
  NAVIGATION_DRAWER_PROFILE: 'Menu_Profile', //
  NAVIGATION_DRAWER_MEMBERSHIP: 'Menu_Membership', //

  NEW_ORDER_SHOW_ORDER_FORM: 'NewOrder - show order form', // not use
  NEW_ORDER_HIDE_ORDER_FORM: 'NewOrder - hide order form', // not use
  NEW_ORDER_SERVICE_ITEM_CLICKED: 'NewOrder_select_service', //
  NEW_ORDER_SERVICE_NAV_CLICKED: 'NewOrder - service navigation clicked', // not use
  NEW_ORDER_SERVICE_HINT_CLICKED: 'NewOrder_show_description', //

  NEW_ORDER_GPS_BTN: 'NewOrder - gps_btn', // not use

  NEW_ORDER_POINT_CLICKED: 'NewOrder_select_location', //
  NEW_ORDER_CLICKED_ADDRESS_BOX: 'NewOrder_search_location', //
  NEW_ORDER_ADD_MORE_BTN: 'NewOrder_add_stop_point', //
  NEW_ORDER_ADD_RECIPIENT_INFO_BTN: 'NewOrder_add_recipient_info', //
  NEW_ORDER_REMOVE_POINT_BTN: 'NewOrder - remove_point_btn', // not use
  NEW_ORDER_OPTIMIZE_ROUTE_BTN: 'NewOrder_optimize_route_btn', //
  NEW_ORDER_OPTIMIZE_SERVICE_CONFIRM: 'NewOrder_optimize_service_confirm', //
  NEW_ORDER_OPTIMIZE_SERVICE_DENY: 'NewOrder_optimize_service_deny', //

  NEW_ORDER_SPECIAL_REQUEST_ITEM_CLICKED: 'PlaceOrder_add_request', //
  NEW_ORDER_PROMO_CODE: 'PlaceOrder_add_promo_code', //
  NEW_ORDER_FIND_PROMO_CODE: 'PlaceOrder_find_promo_code', //
  NEW_ORDER_REMARKS: 'NewOrder - input_remarks', // not use

  NEW_ORDER_SPECIAL_REQUEST_FRAGILE_PACKAGE: 'PlaceOrder_request_fragile_package', //
  NEW_ORDER_SPECIAL_REQUEST_FRAGILE_PACKAGE_SELECT_ITEM:
    'PlaceOrder_request_fragile_package_select_item', //
  NEW_ORDER_SPECIAL_REQUEST_FRAGILE_PACKAGE_CONFIRM: 'PlaceOrder_request_fragile_package_confirm', //

  NEW_ORDER_ADD_MORE_IMAGE_BTN: 'PlaceOrder_photo', //
  NEW_ORDER_REMOVE_IMAGE_BTN: 'NewOrder - remove_image_btn', // not use
  NEW_ORDER_VIEW_IMAGE: 'NewOrder - view image click', // not use
  NEW_ORDER_ZOOM_IMAGE: 'NewOrder - zoom image', // not use

  NEW_ORDER_CONTINUE: 'NewOrder_continue', //
  NEW_ORDER_SHOW_ESTIMATED_FEE_DETAILS: 'PlaceOrder_price_details', //
  NEW_ORDER_PURCHASE: 'PlaceOrder_book_btn', //
  NEW_ORDER_PURCHASE_SUCCESS: 'PlaceOrder_order_created', //
  NEW_ORDER_PURCHASE_ERROR: 'PlaceOrder_order_created_fail', //
  NEW_ORDER_WARNING_COD: 'NewOrder_add_recipient_info_warning_COD', //
  NEW_ORDER_WARNING_SURGE_PRICING: 'PlaceOrder_warning_surge_pricing', //
  NEW_ORDER_WARNING_SURGE_PRICING_CONFIRM: 'PlaceOrder_warning_surge_pricing_confirm', //
  NEW_ORDER_SCHEDULE_ORDER: 'NewOrder_schedule_order',
  NEW_ORDER_SCHEDULE_BOOK_NOW_BTN: 'PlaceOrder_schedule_book_now_btn',
  NEW_ORDER_SCHEDULE_CONFIRM_BTN: 'PlaceOrder_schedule_confirm_btn',
  NEW_ORDER_SET_TIME_BTN: 'PlaceOrder_schedule', // "NewOrder - set_time_btn_confirm", //

  NEW_ORDER_NOT_SHOW_RO_TOUR_AGAIN: 'NewOrder_not_show_ro_tour_again',
  NEW_ORDER_START_RO_TOUR: 'NewOrder_start_ro_tour',
  NEW_ORDER_SWITCH_NEW_UI_VERSION_2: 'NewOrder_switch_new_ui_version_2',
  NEW_ORDER_STAY_OLD_UI_VERSION_1: 'NewOrder_stay_old_ui_version_1',

  // Pin on map
  NEW_ORDER_CLICK_PIN_LOCATION: 'NewOrder_click_pin_location',
  NEW_ORDER_CLICK_PIN_LOCATION_CONFIRM: 'NewOrder_click_pin_location_confirm',

  NEW_ORDER_SHOW_VERIFY_COD_FORM: 'PlaceOrder_COD_not_allowed_show', //
  PLACE_ORDER_COD_NOT_ALLOWED_CLOSE: 'PlaceOrder_COD_not_allowed_close',
  VERIFY_COD_SUCCESS: 'PlaceOrder_verify_COD_done_btn', //
  VERIFY_COD_FB_SUCCESS: 'PlaceOrder_verify_COD_with_fb_sucessfully', //
  VERIFY_COD_FB_ERROR: 'PlaceOrder_verify_COD_with_fb_failed', //
  VERIFY_COD_BY_FACEBOOK: 'PlaceOrder_verify_COD_with_fb_btn', //
  PLACE_ORDER_TOP_UP_BTN: 'PlaceOrder_top_up_btn',

  PLACE_ORDER_PHOTO_SUBMIT: 'PlaceOrder_photo_submit',
  PLACE_ORDER_CHANGE_PAYMENT_METHOD: 'PlaceOrder_change_payment_method_btn',
  PLACE_ORDER_SELECT_PAYMENT_METHOD: 'PlaceOrder_select_payment_method_btn',

  UPLOAD_IMAGE_UPLOAD_TAB: 'UploadImage - upload_tab', //
  UPLOAD_IMAGE_RECENT_TAB: 'UploadImage - recent_tab', //
  UPLOAD_IMAGE_BACK_BTN: 'UploadImage - back_btn', //
  UPLOAD_IMAGE_SELECT_A_RECENT_IMAGE: 'UploadImage - select_a_recent_image', //

  LOGIN_SUBMIT_BTN: 'Login_login_btn', //
  LOGIN_REGISTER_BTN: 'Login_register_btn', //
  LOGIN_PHONE: 'Login_input_phone', //
  LOGIN_FACEBOOK_BTN: 'Login_fb_login_btn', //
  LOGIN_FACEBOOK_SUCCESS: 'Login_facebook_success', //
  LOGIN_FACEBOOK_FAIL: 'Login_facebook_fail', //
  LOGIN_GOOGLE_BTN: 'Login_google_login_btn', //
  LOGIN_GOOGLE_SUCCESS: 'Login_google_sign_in_success', //
  LOGIN_GOOGLE_FAIL: 'Login_google_sign_in_fail', //
  LOGIN_POPUPS_BLOCKED: 'Login_popups_blocked',
  LOGIN_SUCCESS: 'Login_success', //
  LOGIN_FAIL: 'Login_fail', //
  LOGIN_WITH_ACCOUNT_KIT: 'Login_by_account_kit',
  LOGIN_ACTIVATE_AHA_CODE: 'Login_activate_aha_code',
  LOGIN_ACTIVATE_AHA_ERROR: 'Login_activate_aha_error',
  LOGIN_ACTIVATE_FIREBASE_TOKEN_ERROR: 'Login_activate_firebase_token_error',
  LOGIN_ACTIVATE_FIREBASE_TOKEN: 'Login_activate_firebase_token',
  LOGIN_ACTIVATE_FIREBASE_CODE_ERROR: 'Login_activate_firebase_code_error',
  LOGIN_ACTIVATE_FIREBASE_CODE_NOT_SENT: 'Login_activate_firebase_code_not_sent',
  LOGIN_ACTIVATE_FIREBASE_RECAPTCHA_ERROR: 'Login_activate_firebase_recaptcha_error',
  LOGIN_ACTIVATE_FIREBASE_MISSING_PHONE_NUMBER: 'Login_activate_firebase_missing_phone_number',
  LOGIN_ACTIVATE_FIREBASE_CANCEL_WHILE_PROCESS: 'Login_activate_firebase_cancel_while_process',
  LOGIN_ACTIVATE_RESEND_CODE: 'Login_active_resend_code',
  LOGIN_ACTIVATE_CHANGE_PHONE_NUMBER: 'Login_active_change_phone_number',
  LOGIN_REQUEST_FAIL: 'Login_request_fail',

  REGISTER_BACK_BTN: 'Register - back_btn',
  REGISTER_SUBMIT_BTN: 'Register_submit_btn', //
  REGISTER_LOGIN_BTN: 'Register - login_btn', //
  REGISTER_POLICY_BTN: 'Register_term_and_condition_btn', //
  REGISTER_NAME: 'Register_input_name', //
  REGISTER_PHONE: 'Register_input_phone', //
  REGISTER_EMAIL: 'Register_input_email', //
  REGISTER_REFERRAL_CODE: 'Register_referral_code', //
  REGISTER_SUCCESS: 'Register_success', //
  REGISTER_FAIL: 'Register_fail', //

  ACTIVATE_ACCOUNT_SHOW_FORM: 'ActivateAccount_show_active_form', //
  ACTIVATE_ACCOUNT_BACK_BTN: 'ActivateAccount_back_btn',
  ACTIVATE_ACCOUNT_SUBMIT_BTN: 'ActivatePhone_activate_btn', //

  LOGOUT_SHOW_CONFIRM_FORM: 'Logout - show_confirm_form',
  LOGOUT_BACK_BTN: 'Logout - back_btn',
  LOGOUT_SUCCESS: 'Logout - success',

  PROFILE_SIGN_OUT: 'Profile_sign_out',

  RECORDS_ITEM_CLICKED: 'Records_item_clicked', //
  RECORDS_STATUS_FILTER: 'Records_select_filter', //
  RECORDS_SCROLL_DOWN: 'Records_scroll_down',
  RECORDS_DOWNLOAD_CSV: 'Records_download_csv_click', //
  RECORDS_DOWNLOAD_CSV_CANCEL: 'Records_download_csv_click_cancel', //
  RECORDS_FILTER_BY_TAG: 'Records_filter_by_tag', //
  RECORDS_FILTER_BY_KEYWORD: 'Records_filter_by_key_word', //

  ORDER_DETAIL_REUSE_BTN: 'OrderDetail_reuse_btn', //
  ORDER_DETAIL_REORDER_BTN: 'OrderDetail_reorder_btn', //
  ORDER_DETAIL_REORDER_CONFIRM_BTN: 'OrderDetail - reorder_btn confirm clicked', //
  ORDER_DETAIL_SHARE_BTN: 'OrderDetail_share_btn', //
  ORDER_DETAIL_CANCEL_ORDER_BTN: 'OrderDetail_cancel_btn', //
  ORDER_DETAIL_SHOW_RATING_FORM_BTN: 'OrderDetail_show_rating_modal', //
  ORDER_DETAIL_CANCELLED_ORDER_POPUP_CLOSE_BTN: 'OrderDetail - cancelled_order_popup_close_btn', //
  ORDER_DETAIL_CANCELLED_ORDER_POPUP_RETRY_BTN: 'OrderDetail - cancelled_order_popup_retry_btn', //
  ORDER_DETAIL_HELP_BTN: 'OrderDetail_report', //
  ORDER_DETAIL_UPDATE_BTN: 'OrderDetail_update_address_btn', //
  ORDER_DETAIL_CREATE_TAG: 'OrderDetail_create_tag',
  ORDER_DETAIL_SET_TAG: 'OrderDetail_set_tag',
  ORDER_DETAIL_DELETE_TAG: 'OrderDetail_delete_tag',

  ORDER_DETAIL_PRINT_BILL: 'OrderDetail_print_bill',
  ORDER_DETAIL_PRINT_BILL_MOUNTED: 'OrderDetail_print_bill_mounted',

  CANCEL_ORDER_FORM_CANCEL_BTN: 'CancelOrderForm - cancel_btn',
  CANCEL_ORDER_FORM_CONFIRM_BTN: 'CancelOrderForm - confirm_btn', //

  MESSAGE_SHOW_CHATBOX: 'OrderDetail_sms_driver_btn', //
  MESSAGE_HIDE_CHATBOX: 'MESSAGE - hide_chatbox', //
  MESSAGE_CALL_BTN_CLICKED: 'OrderDetail_call_driver_btn', //

  HELP_CHANGE_REPORT_TYPE: 'Help - report_type_selected', //
  HELP_CHANGE_ORDER_REPORT_TYPE: 'Help - order_report_type_selected', //
  HELP_SUBMIT_FORM: 'OrderDetail_report', //
  HELP_CANCEL_FORM: 'Help - cancel_form', //

  RATE_SUPPLIER_RATE_CLICK: 'RateSupplier - rate item click', //
  RATE_SUPPLIER_SUBMIT_BTN: 'OrderDetail_driver_rating_submit_btn', //
  RATE_SUPPLIER_CLOSE_BTN: 'RateSupplier - close_btn', //

  REFERRAL_CODE_EDIT_BTN: 'Invite_edit_btn', //
  REFERRAL_CODE_EDIT_CONFIRM_BTN: 'Invite_update_code_btn', //
  REFERRAL_CODE_EDIT_CANCEL_BTN: 'Invite_cancel_update_code_btn',
  REFERRAL_CODE_POLICY_BTN: 'Invite_how_to_btn', //
  REFERRAL_CODE_FACEBOOK_SHARE_BTN: 'Invite_send_invite_btn', //
  REFERRAL_CODE_TW_SHARE_BTN: 'ReferralCode - tw_share_btn', //
  REFERRAL_CODE_GPL_SHARE_BTN: 'ReferralCode - gpl_share_btn', //

  PICKUP_LOCATION_GPS_BTN: 'PickupLocation - gps_btn', //
  PICKUP_LOCATION_PIN_MAP_OPTION: 'PickupLocation - pin on map', //
  PICKUP_LOCATION_RECENT_POINT_CLICKED: 'PickupLocation - recent_point_clicked', //
  PICKUP_LOCATION_HOME_ADDRESS_CLICKED: 'PickupLocation - home address clicked', //
  PICKUP_LOCATION_WORK_ADDRESS_CLICKED: 'PickupLocation - work address clicked', //
  PICKUP_LOCATION_SEARCH_RESULT_POINT_CLICKED: 'PickupLocation - search_result_point_clicked', //
  PICKUP_LOCATION_GOOGLE_SEARCH: 'PickupLocation - google search option clicked', //
  SEARCH_LOCATION_SELECT_A_KONTAKTE_RESULT: 'SearchLocation - select a kontakte result', //

  USER_PROFILE_OVERVIEW_EDIT_BTN: 'Profile_edit_profile', //
  USER_PROFILE_OVERVIEW_CANCEL_BTN: 'UserProfile - overview_cancel_btn', //
  USER_PROFILE_OVERVIEW_SUBMIT_BTN: 'UserProfile - overview_submit_btn', //
  USER_PROFILE_STATISTICS_CHANGE_RANGE: 'UserProfile - statistics_change_range', //
  USER_PROFILE_USER_ADDRESS_EDIT_BTN: 'UserProfile - user_address_edit_btn', //
  USER_PROFILE_USER_ADDRESS_CANCEL_BTN: 'UserProfile - user_address_cancel_btn', //
  USER_PROFILE_USER_ADDRESS_SUBMIT_BTN: 'UserProfile - user_address_submit_btn', //
  USER_PROFILE_CATEGORY_SUBMIT_BTN: 'Profile_category_save_btn', //
  USER_PROFILE_SELECT_BUSSINESS_TYPE: 'Profile_category_select_business_type',
  USER_PROFILE_SELECT_AVATAR: 'MyAccount_Avatar',
  USER_PROFILE_AVATAR_CLOSE_BTN: 'MyAccount_Avatar_close_btn',

  USER_PROFILE_APP_VERSION_BTN: 'Profile_app_version_btn', //

  // User Balance

  BALANCE_SELECT_AMOUNT_OPTION: 'Balance_select_amount_option',
  BALANCE_SELECT_TOP_UP_METHOD: 'Balance_select_top_up_method',
  BALANCE_CLICKED_ORDER_ID: 'Balance_transaction_history_select_item', //
  BALANCE_PROCESS_TOP_UP_BTN: 'Balance_process_top_up_btn',
  BALANCE_COD_STATISTICS: 'Balance_cod_statistics',
  BALACNE_COD_STATISTICS_TODAY: 'Balance_cod_statistics_today',
  BALACNE_COD_STATISTICS_7_DAYS: 'Balance_cod_statistics_7_days',
  BALANCE_COD_STATISTICS_LAST_30_DAYS: 'Balance_cod_statistics_last_30_days',
  BALANCE_COD_STATISTICS_CUSTOM: 'Balance_cod_statistics_custom',
  BALANCE_COD_STATISTICS_CUSTOM_APPLY: 'Balance_cod_statistics_custom_apply',
  BALANCE_COD_ADD_ACCOUNT_BTN: 'Balance_cod_add_account_btn',
  BALANCE_COD_ADD_ACCOUNT_LATER_BTN: 'Balance_cod_add_account_later_btn',
  BALANCE_COD_WITHDRAWAL_SELECT_AMOUNT: 'Balance_cod_withdrawal_select_amount',
  BALANCE_COD_WITHDRAWAL_CONTINUE: 'Balance_cod_withdrawal_continue',
  BALANCE_COD_WITHDRAWAL_TRANSACTION_CONFIRM: 'Balance_cod_withdrawal_transaction_confirm',
  BALANCE_COD_WITHDRAWAL_TRANSACTION_BACK: 'Balance_cod_withdrawal_transaction_back',
  BALANCE_COD_AUTO_WITHDRAWAL: 'Balance_cod_auto_withdrawal',
  BALANCE_COD_AUTO_WITHDRAWL_POPUP_CONFIRM: 'Balance_cod_auto_withdrawl_popup_confirm',
  BALANCE_COD_AUTO_WITHDRAWL_POPUP_CANCEL: 'Balance_cod_auto_withdrawl_popup_cancel',
  BALANCE_BANK_ACCOUNT_BTN: 'Balance_bank_account_btn',
  BALANCE_BANK_ADD_ACCOUNT_BTN: 'Balance_bank_add_account_btn',
  BALANCE_BANK_ADD_ACCOUNT_LATER_BTN: 'Balance_bank_add_account_later_btn',
  BALANCE_BANK_ACCOUNT_SUBMIT: 'Balance_bank_account_submit',
  BALANCE_BANK_ACCOUNT_NOT_ALLOWED: 'Balance_bank_account_not_allowed',
  BALANCE_BANK_ACCOUNT_ALLOWED: 'Balance_bank_account_allowed',
  BALANCE_BANK_ACCOUNT_NOT_ALLOWED_CLOSE: 'Balance_bank_account_not_allowed_close',
  BALANCE_BANK_ACCOUNT_ALLOWED_CONTINUE: 'Balance_bank_account_allowed_continue',
  BALANCE_BANK_ACCOUNT_ALLOWED_BACK: 'Balance_bank_account_allowed_back',
  BALANCE_BANK_ACCOUNT_RESEND_OTP: 'Balance_bank_account_resend_OTP',
  BALANCE_BANK_ACCOUNT_RESEND_OTP_CLOSE: 'Balance_bank_account_resend_OTP_close',
  BALANCE_BANK_ACCOUNT_MANAGE_BTN: 'Balance_bank_account_manage_btn',
  BALANCE_BANK_ACCOUNT_DELETE: 'Balance_bank_account_delete',
  BALANCE_BANK_ACCOUNT_EDIT: 'Balance_bank_account_edit',
  BALANCE_BANK_ACCOUNT_EDIT_SAVE: 'Balance_bank_account_edit_save',

  MANAGE_EMPLOYEES_ADD_ERROR: 'MANAGE_EMPLOYEES - add_error', //
  MANAGE_EMPLOYEES_ADD_SUCCESS: 'MANAGE_EMPLOYEES - add_success', //
  MANAGE_EMPLOYEES_REMOVE_SUCCESS: 'MANAGE_EMPLOYEES - remove_success', //
  MANAGE_EMPLOYEES_REMOVE_ERROR: 'MANAGE_EMPLOYEES - remove_error', //
  MANAGE_EMPLOYEES_ACTIVATE_CODE: 'MANAGE_EMPLOYEES - add_activate_code', //

  ROUTE_PLANNER_GET_SEARCH_RESULT: 'RoutePlanner - get_search_result',
  ROUTE_PLANNER_SEARCH_RESULT_CLICKED: 'RoutePlanner - search_result_clicked', //
  ROUTE_PLANNER_SERVICE_SELECT: 'RoutePlanner - service_selected', //
  ROUTE_PLANNER_DATETIME_CLICKED: 'RoutePlanner - datetime_clicked', //
  ROUTE_PLANNER_ROUNDTRIP_CLICKED: 'RoutePlanner - roundtrip_clicked', //
  ROUTE_PLANNER_STOPPOINT_SELECTED: 'RoutePlanner - stoppoint_selected', //

  ROUTE_PLANNER_CONFIRM_REMOVE_ADD_BTN: 'RoutePlanner - confirm_remove_address_clicked', //

  ROUTE_PLANNER_EDIT_ADD_BTN: 'RoutePlanner - edit_address_clicked', //
  ROUTE_PLANNER_RO_REQUEST_ERROR: 'RoutePlanner - request_API_error', //

  ROUTE_PLANNER_OPTIMIZE_BTN: 'RoutePlanner - optimize_btn_clicked', //
  ROUTE_PLANNER_BACK_BTN: 'RoutePlanner - back_btn_clicked', //
  ROUTE_PLANNER_EXPORT_INVALID_ORDER_POINTS: 'RoutePlanner - export_invalid_order_points', //
  ROUTE_PLANNER_VIEWMAP_BTN: 'RoutePlanner - view_map_btn_clicked', //
  ROUTE_PLANNER_CREATE_ALL_ORDERS_BTN: 'RoutePlanner - create_all_order_btn_clicked', //

  ROUTE_PLANNER_CREATE_BTN: 'RoutePlanner - create_btn_clicked', //
  ROUTE_PLANNER_REMOVE_ORDER_BTN: 'RoutePlanner - remove_order_btn_clicked', //
  ROUTE_PLANNER_SAVE_TO_DRAFT_BTN: 'RoutePlanner - save_to_draft_clicked',
  ROUTE_PLANNER_CHOOSE_DRAFT: 'RoutePlanner - choose_draft_clicked', //
  ROUTE_PLANNER_REMOVE_DRAFT: 'RoutePlanner - remove_draft_clicked', //
  ROUTE_PLANNER_DOWNLOAD_DRAFT: 'RoutePlanner - download_draft_clicked', //
  ROUTE_PLANNER_UPLOAD_FILE: 'RoutePlanner - upload_stop_points_file', //
  ROUTE_PLANNER_ADD_POINT: 'RoutePlanner - add_point_btn_clicked', //
  ROUTE_PLANNER_IMPORT_SPREADSHEET: 'RoutePlanner - import_spreadsheet', //
  ROUTE_PLANNER_CREATE_ORDER_ERROR: 'RoutePlanner - create_order_api_error', //
  ROUTE_PLANNER_LOAD_PATH_FROM_API_SUCCESS: 'RoutePlanner - load path from api success', //
  ROUTE_PLANNER_LOAD_PATH_FROM_API_ERROR: 'RoutePlanner - load path from api error', //
  ROUTE_PLANNER_SHOW_TOUR_AGAIN: 'RoutePlanner - show_tour_again',
  ROUTE_PLANNER_NOT_SHOW_TOUR_AGAIN: 'RoutePlanner - not_show_tour_again',
  ROUTE_PLANNER_START_TOUR: 'RoutePlanner - start_tour',
  ROUTE_PLANNER_END_TOUR: 'RoutePlanner - end_tour',
  ROUTE_PLANNER_SKIP_TOUR: 'RoutePlanner - skip_tour',
  ROUTE_PLANNER_MOVE_OUT_WHEN_IN_TOUR: 'RoutePlanner - move_out_when_in_tour',

  STATISTIC_DATE_CHANGE: 'STATISTIC - change date filter', //--
  STATISTIC_EMPLOYEE_CHANGE: 'STATISTIC - change employee filter', //--
  STATISTIC_SERVICE_CHANGE: 'STATISTIC - change service filter', //--
  STATISTIC_CHART_TAB: 'STATISTIC - select chart tab', //--
  STATISTIC_MAP_TAB: 'STATISTIC - select map tab', //--

  // SMART BI (docs/smart-bi/analytics-events-spec.md)
  SMART_BI_TAB_VIEW: 'SMART BI - view tab',
  SMART_BI_CHANGE_MONTH: 'SMART BI - change month filter',
  SMART_BI_GENERATE: 'SMART BI - generate report',
  SMART_BI_DOWNLOAD_PDF: 'SMART BI - download pdf',
  SMART_BI_REPORT_SUCCESS: 'SMART BI - report success',
  SMART_BI_REPORT_FAIL: 'SMART BI - report fail',
  SMART_BI_CTA_CLICK: 'SMART BI - click cta',
  SMART_BI_RATING: 'SMART BI - rate report',
  SMART_BI_FEEDBACK_SUBMIT: 'SMART BI - submit feedback',

  NOTIFICATION_CLICK_LEARN_MORE: 'News_dialog_learn_more_btn',
  NOTIFICATION_CLICK_BOOK_NOW: 'News_dialog_book_now_btn',
  NOTIFICATION_CLICK_ITEM: 'News_item_clicked',
  NOTIFICATION_CLICK_ITEM_SHOW: 'News_item_show',
  NOTIFICATION_CLICK_CLOSE_BTN: 'News_dialog_close_btn',

  NEWORDER_SELECT_LOCATION_FAIL: 'NewOrder_select_location_fail',
  NEWORDER_PLACE_ORDER_LOCATION: 'NewOrder_place_order_location', // not use

  SHIPPER_PLACE_ORDER_CONTINUE_BTN_CLICK: 'Shipper_place_order_continue_btn_click',
  SHIPPER_PLACE_ORDER_SUCCESS: 'Shipper_place_order',

  PARTNER_LOAD_MAIN_APP: 'Partner_load_main_app',
  PARTNER_LOAD_BOOKING_LIST: 'Partner_load_booking_list',
  PARTNER_CANCELED_ORDER: 'Partner_canceled_order',

  WAREHOUSE_UPDATE_STATUS: 'Warehouse_update_status',

  VERIFYORDER_SUBMIT: 'Verifyorder_submit',

  VISUALIZATION_OPEN: 'Visualization_open',

  SELECT_A_PAGE_BY_FACEBOOK: 'PlaceOrder_verify_COD_with_fb_page_item_selected',
  CONFIRM_RETURN_PACKAGE_BTN: 'OrderDetail - confirm_return_package_btn',

  // Page Inbox
  PAGE_INBOX_SHOW_CONVERSATION_LIST: 'PageInbox - show_converstaion_list',
  PAGE_INBOX_HIDE_CONVERSATION_LIST: 'PageInbox - hide_converstaion_list',
  PAGE_INBOX_SELECT_A_PAGE: 'PageInbox - select_a_page',
  PAGE_INBOX_SELECT_A_CONVERSATION: 'PageInbox - select_a_conversation',
  PAGE_INBOX_USE_CONTACT: 'PageInbox - use_contact',
  PAGE_INBOX_SET_MSG_TO_ADDRESS: 'PageInbox - set_msg_to_address',
  PAGE_INBOX_SET_MSG_TO_NAME: 'PageInbox - set_msg_to_name',
  PAGE_INBOX_SET_MSG_TO_MOBILE: 'PageInbox - set_msg_to_mobile',
  PAGE_INBOX_SET_MSG_TO_REMARKS: 'PageInbox - set_msg_to_remarks',
  PAGE_INBOX_COPY_MSG: 'PageInbox - copy_msg',
  PAGE_INBOX_CLOSE_CONVESATION: 'PageInbox - close_conversation',
  PAGE_INBOX_SIGN_IN: 'PageInbox - user_sign_in',
  PAGE_INBOX_CREATE_PAGE: 'PageInbox - user_create_a_page',
  PAGE_INBOX_SELECT_INFO_ORDER_SUGGESTION: 'PageInbox - select_order_suggestion',
  PAGE_INBOX_SELECT_SEND_TRACKING_LINK: 'PageInbox - select_send_tracking_link',

  // FORCE LINK SOCIAL

  SKIP_FORCE_LINK_SOCIAL: 'click_skip_force_link_social',

  // Help Center
  HELP_REPORT_ORDER_DEFAULT_BTN: 'HelpCenter - report_order_default_btn',
  HELP_REPORT_OTHER_ORDER_BTN: 'HelpCenter - report_other_order_btn',
  HELP_SELECT_ISSUE: 'HelpCenter - select_issue',
  HELP_REPORT_ORDER_CONTACT_REASON: 'HelpCenter - report_order_with_contact_reason',
  HELP_REPORT_ORDER_SUB_CONTACT_REASON: 'HelpCenter - report_order_with_sub_contact_reason',
  HELP_REPORT_ORDER_ATTACH_IMAGE_BTN: 'HelpCenter - report_order_attach_image',
  HELP_REPORT_ORDER_SUBMIT_BTN: 'HelpCenter - report_order_submit',
  HELP_CALL_HOTLINE: 'HelpCenter - call_hotline',

  // SAVED PLACES
  PROFILE_SAVED_PLACES: 'Profile_saved_places',
  PROFILE_SAVED_PLACES_SELECT_ITEM: 'ProfileSavedPlaces_select_item',
  PROFILE_SAVED_PLACES_NEW_SAVED_PLACE: 'ProfileSavedPlaces_new_saved_place',
  PROFILE_SAVED_PLACES_SAVE_BTN: 'ProfileSavedPlaces_save_btn',
  PROFILE_SAVED_PLACES_ITEM_DELETE_BTN: 'ProfileSavedPlaces_item_delete_btn',
  PROFILE_SAVED_PLACES_ITEM_DELETE_CONFIRM_BTN: 'ProfileSavedPlaces_item_delete_confirm_btn',
  PROFILE_SAVED_PLACES_ITEM_DELETE_CANCEL_BTN: 'ProfileSavedPlaces_item_delete_cancel_btn',
  PROFILE_SAVED_PLACES_ITEM_SAVE_BTN: 'ProfileSavedPlaces_item_save_btn',
  SEARCH_LOCATION_SELECT_CURRENT_LOCATION: 'SearchLocation_select_current_location',
  SEARCH_LOCATION_NEW_SAVED_PLACE: 'SearchLocation_new_saved_place',
  SEARCH_LOCATION_SAVED_PLACES: 'SearchLocation_saved_places',
  SEARCH_LOCATION_SELECT_SAVED_PLACES_ITEM: 'SearchLocation_select_saved_places_item',
  SEARCH_LOCATION_SAVED_PLACES_SELECT_ITEM: 'SearchLocationSavedPlaces_select_item',
  PROFILE_CREATE_TAG: 'Profile_create_tag',

  // SUBSCRIPTION
  SUBSCRIPTION_PACKAGES: 'Subscription_package_click',
  SUBSCRIPTION_SUBSCRIBE_NOW: 'Subscription_package_select_tier',
  SUBSCRIPTION_PACKAGES_GET_PLAN: 'subscription_packages_get_this_plan',
  SUBSCRIPTION_PACKAGES_CYCLE: 'Subscription_package_select_circle',
  SUBSCRIPTION_PAYMENT_METHOD: 'subscription_payment_method',
  SUBSCRIPTION_PAYMENT: 'Payment_purchase_btn',
  SUBSCRIPTION_SUBCRIBE_FAILED: 'subscription_subscribe_failed',
  MY_SUBSCRIPTION_PACKAGES_DETAIL: 'Subcription_my_subscription_btn',
  MY_SUBSCRIPTION_BOOK_NOW: 'MySubscription_book_now',
  MY_SUBSCRIPTION_CANCELLED: 'MySubscription_package_cancel_btn',
  MY_SUBSCRIPTION_CANCELLED_REASON: 'MySubscription_package_cancel_confirm_btn',
  SUBSCRIPTION_PACKAGE_TERM_AND_CONDITIONS: 'Subscription_package_term_and_conditions',
  SUBSCRIPTION_PACKAGE_HOW_TO_USE: 'Subscription_package_how_to_use',
  SUBSCRIPTION_PACKAGE_CIRCLE_CLOSE: 'Subscription_package_circle_close',
  SUBSCRIPTION_VIEW_MY_SUBSCRIPTION: 'Subscription_view_my_subscription',
  MYSUBSCRIPTION_PACKAGE_CLICK: 'MySubscription_package_click',
  MYSUBSCRIPTION_PACKAGE_CANCEL_SELECT_REASON: 'MySubscription_package_cancel_select_reason',
  MYSUBSCRIPTION_PACKAGE_EXTEND_BTN: 'MySubscription_package_extend_btn',
  MYSUBSCRIPTION_FIND_SUBSCRIPTION_LIST: 'MySubscription_find_subscription_list',
  MYSUBSCRIPTION_PACKAGE_CANCEL_BACK_BTN: 'MySubscription_package_cancel_back_btn',

  SUBSCRIPTION_LIST_SCREEN_SHOW: 'subscription_list_screen_show',
  SUBSCRIPTION_LIST_CLOSE_ICON_CLICK: 'subscription_list_close_icon_click',
  SUBSCRIPTION_LIST_VIEW_DETAIL_CLICK: 'subscription_list_view_detail_click',
  SUBSCRIPTION_LIST_MY_SUBSCRIPTION_CLICK: 'subscription_list_my_subscription_click',
  // PAYMENT

  PAYMENT_SELECT_METHOD: 'Payment_select_method',
  PAYMENT_BALANCE_SELECT_TOP_UP: 'Payment_balance_select_top_up',
  PAYMENT_VNPAY_SELECT_INSTRUCTION: 'Payment_vnpay_select_instruction',

  // BOOKING EMBED
  BOOKING_EMBED_PAGE_VIEW: 'Booking_embed_page_view',

  // TIP
  TIP_ENTRYPOINT_BTN: 'Tip_EntryPoint_btn',
  TIP_OPTIONSCREEN_CONFIRM: 'Tip_OptionScreen_Confirm',
  TIP_PAYMENTSCREEN_BTN: 'Tip_PaymentScreen_btn',

  // TRUCK
  TRUCK_ENTRYPOINT_BTN: 'Truck_EntryPoint_btn',
  TRUCK_MAINSCREEN_ADDRESS_CONFIRM: 'Truck_MainScreen_Address_Confirm',
  TRUCK_MAINSCREEN_SCHEDULEBOOKING: 'Truck_MainScreen_ScheduleBooking',
  TRUCK_MAINSCREEN_ITEM: 'Truck_MainScreen_Item',
  TRUCK_MAINSCREEN_WEIGHT: 'Truck_MainScreen_Weight',
  TRUCK_MAINSCREEN_DIMENSION: 'Truck_MainScreen_Dimension',
  TRUCK_MAINSCREEN_NOTE_CLICK: 'Truck_MainScreen_Note_Click',
  TRUCK_MAINSCREEN_CONFIRM_CLICK: 'Truck_MainScreen_Confirm_Click',
  TRUCK_VECHICLELIST_SELECT: 'Truck_VechicleList_Select',
  TRUCK_VECHICLELIST_RESCHEDULE: 'Truck_VehicleList_Reschedule',
  TRUCK_VECHICLELIST_BANHOUR_CONFIRM: 'Truck_VehicleList_BanHour_Confirm',
  TRUCK_VECHICLELIST_CONFIRM: 'Truck_VehicleList_Confirm',

  // VERYFY ACCOUNT EKYC
  SELECT_BUSSINESS_TYPE_EKYC: 'SelectBussinessType_Ekyc',
  SIGNUP_SELECT_BUSSINESS_CLOSE: 'SignUp_select_bussiness_close',
  SELECT_BUSSINESS_TYPE_SELECT: 'SelectBussinessType_select',
  // PASSCODE
  PROFILE_PASSCODE: 'Profile_passcode',
  PASSCODE_INPUT: 'Passcode_input',
  PASSCODE_SUCSESSS: 'Passcode_sucesss',
  PASSCODE_FAILED: 'Passcode_failed',
  LOGIN_REQUEST_PASSCODE: 'Login_request_passcode',
  LOGIN_PASSCODE: 'Login_passcode',
  LOGIN_PASSCODE_RESET: 'Login_passcode_reset',
  LOGIN_PASSCODE_CHECK_PHONE: 'Login_passcode_check_phone',
  LOGIN_PASSCODE_CHECK_PHONE_CLOSE: 'Login_passcode_check_phone_close',
  LOGIN_PASSCODE_CHECK_PHONE_RESEND_LINK: 'Login_passcode_check_phone_resend_link',

  // WRONG OTP
  OTP_INPUT: 'OTP_input',
  OTP_DEACTIVE_POPUP: 'OTP_deactive_popup'
}

export const ACTIONS = {
  CLICK: 'click',
  FILL: 'fill',
  DRAG: 'drag',
  SELECT: 'select',
  SCROLL: 'scroll',
  NON_INTERACTION: 'non_interaction',
  PAGE_VIEW: 'page_view'
}
